const BlockDivisionReducer = (state = {}, action) => {
    switch (action.type) {
      case "BD_LISTVIEW":
        return Object.assign({}, state, {
          BD_ListView: action.data
        });
      case "BDEDIT_DOCS":
        return Object.assign({}, state, {
          geteditbd: action.data
        });
      case "BD_DRAWING":
        return Object.assign({}, state, {
          BD_Drawing: action.data
        });
        case "BDEDIT_DRAWING":
          return Object.assign({}, state, {
            BDEDIT_Drawing: action.data
          });
      default:
        return state;
    }
  };
  
  export default BlockDivisionReducer;